var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_19486)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1489,
    r: 11.5,
    stroke: "#E36650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 7.23983L12.9775 14.8783H11.0279L10.8148 7.23983H13.1852ZM12.0027 18.2874C11.6511 18.2874 11.3493 18.1631 11.0971 17.9146C10.845 17.6624 10.7207 17.3606 10.7243 17.009C10.7207 16.661 10.845 16.3627 11.0971 16.1141C11.3493 15.8655 11.6511 15.7413 12.0027 15.7413C12.34 15.7413 12.6365 15.8655 12.8922 16.1141C13.1479 16.3627 13.2775 16.661 13.2811 17.009C13.2775 17.2434 13.2154 17.4582 13.0946 17.6535C12.9775 17.8453 12.823 17.9998 12.6312 18.117C12.4395 18.2306 12.2299 18.2874 12.0027 18.2874Z",
    fill: "#E36650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_19486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.148926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.adef16bb.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_19486)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1489,
    r: 11.5,
    stroke: "#E36650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 7.23983L12.9775 14.8783H11.0279L10.8148 7.23983H13.1852ZM12.0027 18.2874C11.6511 18.2874 11.3493 18.1631 11.0971 17.9146C10.845 17.6624 10.7207 17.3606 10.7243 17.009C10.7207 16.661 10.845 16.3627 11.0971 16.1141C11.3493 15.8655 11.6511 15.7413 12.0027 15.7413C12.34 15.7413 12.6365 15.8655 12.8922 16.1141C13.1479 16.3627 13.2775 16.661 13.2811 17.009C13.2775 17.2434 13.2154 17.4582 13.0946 17.6535C12.9775 17.8453 12.823 17.9998 12.6312 18.117C12.4395 18.2306 12.2299 18.2874 12.0027 18.2874Z",
    fill: "#E36650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_19486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.148926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.adef16bb.svg";
export { ForwardRef as ReactComponent };